<template>
  <el-dialog custom-class="confirm-dialog" v-model="visible" width="500px" :show-close="false" :before-close="handleClose"
    append-to-body>
    <span class="header">
      <el-icon color="#faad14" size="26">
        <Warning />
      </el-icon>
      <span>{{ props.title }}</span>
    </span>
    <div class="message">
      <div>{{ props.message }}</div>
      <slot name="content"></slot>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">{{ $t('ad.cancel') }}</el-button>
        <el-button class="confirm-btn" @click="handleConfirm">
          {{ $t('ad.confirm') }}
        </el-button>
      </span>
    </template>
  </el-dialog>
  <span @click="visible = true">
    <slot></slot>
  </span>
</template>

<script lang="ts">
import { ref, defineEmit, onMounted, defineComponent } from 'vue'
export default defineComponent({
  name: 'Confirm',
  props: {
    title: String,
    message: String,
    confirm: Function,
  },
  setup(props, { emit }) {
    const visible = ref(false)
    const handleClose = () => {
      visible.value = false
    }
    const handleConfirm = () => {
      emit('confirm')
      handleClose()
    }
    return{
      visible,
      handleClose,
      handleConfirm,
      props,
    }
  }
})

</script>
<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-bottom: 20px;

  span {
    padding-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8500);
  }
}

.message {
  margin-left: 54px;
  margin-right: 54px;
  line-height: 26px;
  font-size: 16px;
  min-height: 60px;
  :first-child{
    word-break: break-word;
  }
}

.confirm-btn {
  background-color: #f5222d;
  color: #ffffff;
}

:global(.confirm-dialog .el-dialog__body) {
  padding: 0px;
}
</style>